/* eslint-disable no-unused-vars */
/* eslint-disable */
import {
  Accordion,
  AccordionDetails,
  styled,
  Typography,
  withStyles,
  CircularProgress,
} from '@material-ui/core';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import {
  ExpandLess,
  AddCircleOutlineRounded,
  DeleteOutlineOutlined,
  Search as SearchIcon,
} from '@material-ui/icons';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import PF2MAlertDialog from '~/components/PF2MAlertDialog';
import PF2MEquipmentPool from '~/components/PF2MEquipmentPoolV2';
import PF2MFullScreenButton from '~/components/PF2MFullScreenButton';
import PF2MSearchInput from '~/components/PF2MSearchInput';
import PF2MIconButton from '~/components/PF2MIconButton';
import {
  setSelectedLoadAllocation,
  setSelectedTruckAllocation,
  deallocateAllLoadAllocations,
  deallocateTruckAllocations,
  updateLoadAllocations,
  updateTruckAllocations,
  deallocateLoadAllocations,
  setPendingTruckAllocationUpdate,
  getDispatchOriginsTrucks,
  getDispatchOriginsExcavators,
  getEquipmentStatuses,
  getLoadAllocations,
  getTruckAllocations,
  getBlacklistAllocations,
  getSyncStatus,
  updateIsTruckAllocationLoading,
  getLoadMaterialMappings,
  bulkUpdateDynamic,
  getDynamicConfiguration,
  getLoadAllocationsGroups,
} from '~/store/dispatch/actions';
import {
  checkModulePermission,
  DispatchDragNDropTypes,
  DispatchStatus,
  DispatchStatusNumber
} from '~/utils';
import styles from '../styles';
import TruckAllocationModal from './TruckAllocationModal';
import TruckAllocationModeModal from './TruckAllocationModeModal';
import AllocationRowV2 from './AllocationRowV2';
import { getCodes, getOperators, getTabletConfiguration } from '~/store/manager/actions';
import {
  getEquipmentTypes,
  getEquipmentGroups,
  getElements,
  getSubElements,
  getMaterials,
} from '~/store/nref/actions';
import icons from '~/utils/modulesIcons';

import useRealtimeSignal from '../../useMqtt/useRealtimeSignal';
import useThrottledRealtimeRefresh from '../../useMqtt/useThrottledRealtimeRefresh';
import { calculateDurationBytimestamp } from '~/utils/moment';
import UpdateLoadAllocationModalV2 from '../UpdateLoadAllocationModalV2';
import BulkDynamicAllocationModal from '../BulkDynamicAllocationModal';
import UpdateDynamicAllocationModal from '../UpdateDynamicAllocationModal';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import PF2MTooltip from '~/components/PF2MTooltip';
import PF2MEquipmentPoolFilter from '~/components/PF2MEquipmentPoolFilter';
import { getSelectedAllocationInitialState } from '../utils';
import { getCodeFromStatus, toCodesMapByKey } from '~/utils/codes';

const AccordionSummary = styled(props => (
  <MuiAccordionSummary
    {...props}
  />
))(() => ({
  minHeight: '10px !important',
  '& .MuiAccordionSummary-content': {
    margin: 5,
  },
}));

const TRUCK = 2;

const AllocationsTabV2 = ({ classes }) => {
  const rootRef = React.useRef(0);
  const handle = useFullScreenHandle();

  const dispatch = useDispatch();

  const { t: translate } = useTranslation();

  // estados p/ controle interno
  const [poolEquipmentType, setPoolEquipmentType] = useState([]);
  const [poolEquipmentGroup, setPoolEquipmentGroup] = useState([]);
  const [poolEquipmentName, setPoolEquipmentName] = useState('');

  const [filterTextLoad, setFilterTextLoad] = useState('');
  const [filterTextTruck, setFilterTextTruck] = useState('');
  const [filterTextOrigin, setFilterTextOrigin] = useState('');
  const [dynamicBulkUpdateMessage, setDynamicBulkUpdateMessage] = useState('')

  const [expanded, setExpanded] = useState(true);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [isLoadModalOpen, setIsLoadModalOpen] = useState(false);
  const [isTruckModalOpen, setIsTruckModalOpen] = useState(false);
  const [isDeallocationAlertOpen, setIsDeallocationAlertOpen] = useState(false);
  // const [showBlacklistAllocationModal, setBlacklistAllocationModal] = useState(false);
  const [isBulkInsertOpen, setIsBulkInsertOpen] = useState(false);
  const [isDynamicBulkUpdateConfirmationOpen, setIsDynamicBulkUpdateConfirmationOpen] = useState(false);
  const [isUpdateDynamicAllocationModal, setIsUpdateDynamicAllocationModal] = useState(false);

  // const [blacklistAllocationMessage, setblacklistAllocationMessage] = useState(null);

  // selectors
  const authLevel = useSelector(state => state.auth.user.level);

  const codes = useSelector(state => state.manager.codes);
  const operators = useSelector(state => state.manager.operators);

  const syncStatus = useSelector(state => state.dispatch.syncStatus);
  const loadAllocations = useSelector(state => state.dispatch.loadAllocations);
  const truckAllocations = useSelector(state => state.dispatch.truckAllocations);
  const equipmentStatuses = useSelector(state => state.dispatch.equipmentStatuses);
  const truckOriginsAllocations = useSelector(state => state.dispatch.truckOrigins);
  const loadMaterialMappings = useSelector(state => state.dispatch.loadMaterialMappings);
  // const blacklistAllocations = useSelector(state => state.dispatch.blacklistAllocations);
  const dynamicConfiguration = useSelector(state => state.dispatch.dynamicConfiguration);
  const loadAllocationsGroups = useSelector(state => state.dispatch.loadAllocationsGroups);
  const selectedLoadAllocation = useSelector(state => state.dispatch.selectedLoadAllocation)
  const isTruckAllocationLoading = useSelector(state => state.dispatch.isTruckAllocationLoading);
  const excavatorOrigins = useSelector(state => state.dispatch.excavatorOrigins);
  const pendingTruckAllocationUpdate = useSelector(state => state.dispatch.pendingTruckAllocationUpdate);

  const elements = useSelector(state => state.nref.elements);
  const materials = useSelector(state => state.nref.materials);
  const subElements = useSelector(state => state.nref.subElements);
  const equipmentGroups = useSelector(state => state.nref.equipmentGroups);
  const equipmentTypes = useSelector(state => state.nref.equipmentTypes)
    .filter(r => [1, 2, 15, 29].includes(r.id));

  const roles = useSelector(state => state.auth.user._roles);
  const hasDynamicModule = checkModulePermission(roles, 'DYNAMIC');
  const tabletConfig = useSelector(state => state.manager.tabletConfiguration);
  const tcDynamicConfig = tabletConfig.find(tc => tc.key === 'dynamic_allocation');
  const tcDynamicConfigValue = Number(tcDynamicConfig?.value);

  const isDynamicEnable = hasDynamicModule && Boolean(tcDynamicConfigValue);


  const bulkUpdateDynamicMessageMapper = {
    'active': translate('validation:BulkActiveDynamic'),
    'inactive': translate('validation:BulkInactiveDynamic'),
  }

  const createMapById = (array, key) => useMemo(
    () => Object.fromEntries(array?.map(item => [item[key], item]) || []),
    [array]
  );

  useEffect(() => {
    if (!dataLoaded) {
      dispatch(getCodes());
      dispatch(getElements());
      dispatch(getOperators());
      dispatch(getMaterials());
      dispatch(getSubElements());
      dispatch(getEquipmentTypes());
      dispatch(getEquipmentGroups());
      dispatch(getTabletConfiguration());
      dispatch(getLoadMaterialMappings());
      dispatch(getDynamicConfiguration());
      dispatch(getLoadAllocationsGroups());
      dispatch(getSyncStatus());

      setDataLoaded(true);
    }
  })

  const refreshBoard = useCallback(() => {
    dispatch(getLoadAllocations());
    dispatch(getTruckAllocations({
      finallyCb: () => dispatch(updateIsTruckAllocationLoading(false)),
    }));
    dispatch(getBlacklistAllocations());

    dispatch(getEquipmentStatuses());
    dispatch(getDispatchOriginsTrucks());
    dispatch(getDispatchOriginsExcavators());
  }, [dispatch]);

  const { signal } = useThrottledRealtimeRefresh({
    refresh: refreshBoard,
    throttleMs: 1000,
  });

  useRealtimeSignal({
    topic: 'DISPATCHUPDATE',
    onSignal: signal,
  });


  const statusByEquipId = createMapById(equipmentStatuses, 'id_equip');
  const codesByKey = useMemo(() => toCodesMapByKey(codes), [codes]);
  const operatorById = createMapById(operators, 'id_operator');
  const materialById = createMapById(materials, 'id');
  const elementById = createMapById(elements, 'id');
  const subElementById = createMapById(subElements, 'id');
  const syncStatusByEquipId = createMapById(syncStatus, 'equip_id');
  const dynamicConfigurationByLoadAllocationId = createMapById(dynamicConfiguration, 'load_allocation_id');
  const truckOriginsAllocationsById = createMapById(truckOriginsAllocations, 'equip_id')
  const loadOriginsAllocationsById = createMapById(excavatorOrigins, 'equip_id');

  const durationsByTruckOrigins = truckAllocations.map(truck => {
    const status = statusByEquipId[truck.equip_id];
    const code = getCodeFromStatus(codesByKey, status);
    const codeType = code?.code_type;
    const origin = truckOriginsAllocationsById[truck.equip_id];

    const operatorsName = operatorById[status?.id_operator]?.name;
    const currentMaterialName = materialById[origin?.current_material_id]?.name;
    const currentElementName = elementById[status?.element_id]?.name;
    const currentOrigin_pointName = subElementById[status?.point_id]?.name;

    return {
      ...truck,
      codes_id: code?.id,
      start_timestamp: status?.start_timestamp,
      operation_type: origin?.operation_type,
      codes_name: code?.name ?? translate('validation:CodeNotFound'),
      load_allocation_excavator_name: origin?.load_allocation_excavator_name,
      operators_name: operatorsName ?? translate('validation:OperatorNotFound'),
      status: codeType === undefined ? truck.status : DispatchStatusNumber[codeType],
      durations: status ? calculateDurationBytimestamp(status.start_timestamp) : null,
      current_element_name: currentElementName ?? translate('validation:ElementNotFound'),
      current_material_name: currentMaterialName ?? translate('validation:MaterialNotFound'),
      timestamp_sync_request: syncStatusByEquipId[status?.id_equip]?.timestamp_sync_request ?? null,
      current_origin_point_name: currentOrigin_pointName ?? translate('validation:SubElementNotFound'),
    };
  });

  const durationsByExcavatorOrigins = excavatorOrigins.map(load => {
    const status = statusByEquipId[load.equip_id];
    const code = getCodeFromStatus(codesByKey, status);
    const codeType = code?.code_type;

    const operatorsName = operatorById[status?.id_operator]?.name;
    const currentMaterialName = materialById[load?.current_material_id]?.name;
    const currentElementName = elementById[status?.element_id]?.name;
    const currentOriginPointName = subElementById[status?.point_id]?.name;

    return {
      ...load,
      codes_id: code?.id,
      start_timestamp: status?.start_timestamp,
      codes_name: code?.name ?? translate('validation:CodeNotFound'),
      operators_name: operatorsName ?? translate('validation:OperatorNotFound'),
      status: codeType === undefined ? load.status : DispatchStatusNumber[codeType],
      durations: status ? calculateDurationBytimestamp(status.start_timestamp) : null,
      current_element_name: currentElementName ?? translate('validation:ElementNotFound'),
      current_material_name: currentMaterialName ?? translate('validation:MaterialNotFound'),
      timestamp_sync_request: syncStatusByEquipId[status?.id_equip]?.timestamp_sync_request ?? null,
      current_origin_point_name: currentOriginPointName ?? translate('validation:SubElementNotFound'),
    };
  });

  const truckEquipStatusMapAllocations = truckAllocations
    .filter(truck => truck?.equip_id)
    .map((truck) => {
      const status = statusByEquipId[truck.equip_id];
      const code = getCodeFromStatus(codesByKey, status);
      const codeType = code?.code_type;
      const origin = truckOriginsAllocationsById[truck.equip_id];

      const operatorsName = operatorById[status?.id_operator]?.name;
      const currentMaterialName = materialById[origin?.current_material_id]?.name;
      const currentSubElementName = subElementById[status?.point_id]?.name;

      return {
        ...truck,
        test_status: status,
        status: DispatchStatusNumber[codeType],
        code_id: code?.id,
        codes_name: code?.name ?? translate('validation:CodeNotFound'),
        operators_name: operatorsName ?? translate('validation:OperatorNotFound'),
        operation_type: origin?.operation_type,
        start_timestamp: status?.start_timestamp,
        current_material_name: currentMaterialName ?? translate('validation:MaterialNotFound'),
        timestamp_sync_request: syncStatusByEquipId[status?.id_equip]?.timestamp_sync_request ?? null,
        current_origin_point_name: currentSubElementName ?? translate('validation:SubElementNotFound'),
      };
    });

  const {
    lmmByEquipId,
    lmmByAllocationId,
    lmmByEquipIdAndAllocationId,
  } = useMemo(() => {
    const lmmByEquipId = new Map();
    const lmmByAllocationId = new Map();
    const lmmByEquipIdAndAllocationId = new Map();

    loadMaterialMappings.forEach(lmm => {
      // Por allocation_id
      const allocItems = lmmByAllocationId.get(lmm.load_allocation_id) || [];
      allocItems.push(lmm);
      lmmByAllocationId.set(lmm.load_allocation_id, allocItems);

      // Por equip_id
      const equipItems = lmmByEquipId.get(lmm.equip_id) || [];
      equipItems.push(lmm);
      lmmByEquipId.set(lmm.equip_id, equipItems);

      // Por equip_id e allocation_id !== null
      if (lmm.load_allocation_id) {
        const equipItems = lmmByEquipIdAndAllocationId.get(lmm.equip_id) || [];
        equipItems.push(lmm);
        lmmByEquipIdAndAllocationId.set(lmm.equip_id, equipItems);
      }
    });

    return { lmmByEquipId, lmmByAllocationId, lmmByEquipIdAndAllocationId };
  }, [loadMaterialMappings]);

  const loadEquipStatusAllocations = loadAllocations
    .filter(excavator => excavator?.equip_id)
    .map((excavator) => {

      const status = statusByEquipId[excavator.equip_id];
      const code = getCodeFromStatus(codesByKey, status);
      const codeType = code?.code_type;

      const operatorsName = operatorById[status?.id_operator]?.name;
      const currentOriginPointName = subElementById[status?.point_id]?.name;

      const materialOptions = lmmByEquipId.get(excavator.equip_id);
      const materialMappings = lmmByEquipIdAndAllocationId.get(excavator.equip_id);
      const dynamicConfig = dynamicConfigurationByLoadAllocationId?.[excavator.id];

      const currentMaterialName = materialById[loadOriginsAllocationsById?.[excavator.equip_id]?.current_material_id]?.name;

      const laMaterialMappings = selectedLoadAllocation?.material_mappings?.map(
        (tpl, index) => ({
          ...tpl,
          ...(materialMappings?.[index] ?? {}),
        })
      );
      const laMaterials = laMaterialMappings?.map(mm => mm.material_id);

      return {
        ...selectedLoadAllocation,
        ...excavator,
        origin_element_id: excavator.origin_element_id ?? 0,
        origin_element_point_id: excavator.origin_element_point_id ?? 0,
        status: DispatchStatusNumber[codeType],
        code_id: code?.id,
        codes_name: code?.name ?? translate('validation:CodeNotFound'),
        operators_name: operatorsName ?? translate('validation:OperatorNotFound'),
        durations: status ? calculateDurationBytimestamp(status.start_timestamp) : null,
        current_material_name: currentMaterialName ? currentMaterialName : translate('validation:MaterialNotFound'),
        timestamp_sync_request: syncStatusByEquipId[status?.id_equip]?.timestamp_sync_request ?? null,
        current_origin_point_name: currentOriginPointName ?? translate('validation:SubElementNotFound'),
        material_options: materialOptions,
        dynamic_configuration: dynamicConfig ?? null,
        material_mappings: laMaterialMappings,
        materials: laMaterials,
      };
    });

  const availablePoolEquips = [
    ...truckEquipStatusMapAllocations.filter(
      r => !r.load_allocation_id && r.status !== DispatchStatus.MA,
    ),
    ...loadEquipStatusAllocations.filter(
      r => !r.priority && r.status !== DispatchStatus.MA,
    ),
  ];

  const maintenancePoolEquips = [
    ...truckEquipStatusMapAllocations.filter(
      r => !r.load_allocation_id && r.status === DispatchStatus.MA,
    ),
    ...loadEquipStatusAllocations.filter(
      r => !r.priority && r.status === DispatchStatus.MA,
    ),
  ];

  const applyFiltersToPoolList = (list, listType, listGroup, equipName) => {
    const listFilteredByTypeList = list.filter(
      r => listType.length === 0 || listType.includes(r.equip_type_id)
    );

    const listFilteredByGroup = listFilteredByTypeList.filter(
      r => listGroup.length === 0 || listGroup.includes(r.equip_group_id)
    );

    if (!equipName?.trim()) {
      return listFilteredByGroup;
    }

    const search = equipName?.trim()?.toLowerCase();

    const listFilteredByName = listFilteredByGroup.filter(r =>
      r.equip_name?.toLowerCase()?.includes(search),
    );

    return listFilteredByName;
  };

  // const checkEquipBlacklistAllocations = (item, allocationId) => {
  //   const loadAllocation = loadAllocations.find(la => allocationId === la.id);

  //   const blacklistAllocationTrucksByLoadEquipment = blacklistAllocations.find(
  //     ba => loadAllocation.equip_id === ba.load_id,
  //   )?.trucks || [];

    // if (blacklistAllocationTrucksByLoadEquipment.includes(item.equip_id)) {
    //   const selectedTruckNameOnDrop = item.equip_name;
    //   const selectedLoadNameOnDrop = loadAllocation.equip_name;
    //   setblacklistAllocationMessage(
    //     <div>
    //       {translate('common:TruckEquipment')}
    //       <strong style={{ color: 'red' }}>
    //         {' '}
    //         {selectedTruckNameOnDrop}
    //       </strong>
    //       {translate('common:NotAllowedFor')}
    //       <strong style={{ color: 'red' }}>
    //         {' '}
    //         {selectedLoadNameOnDrop}
    //       </strong>
    //     </div>,
    //   );
    //   setBlacklistAllocationModal(true);
    //   return true;
    // }

  //   return false;
  // };

  const renderEmptyRow = () => (
    <tr>
      <td
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: 90,
          backgroundColor: '#F9F9F9',
          color: '#647886',
          fontSize: '14px',
          fontStyle: 'normal',
          fontFamily: 'Roboto',
        }}
      >
        <span>{translate('common:NoRegisteredAllocations')}</span>
      </td>
    </tr>
  );

  const setEquipmentTypes = (e) => {
    setPoolEquipmentType([...e.target.value.map(r => r.value)]);
    setPoolEquipmentGroup(
      equipmentGroups.filter(
        equip => [...e.target.value.map(target => target.value)]
          .includes(equip.id_equipament),
      ).map(eg => eg.id),
    );
  };

  const filters = React.useMemo(() => ([
    {
      type: 'multiSelect',
      label: `${translate('common:EquipmentType')}`,
      value: poolEquipmentType,
      options: equipmentTypes.map(e => ({
        value: e.id,
        label: e.name,
      })),
      onChange: e => setEquipmentTypes(e),
      placeholder: `${translate('common:Select')}`,
    },
    {
      type: 'multiSelect',
      label: `${translate('common:EquipmentGroup')}`,
      value: poolEquipmentGroup,
      options: equipmentGroups
        .filter(r => poolEquipmentType.includes(r.id_equipament))
        .map(e => ({
          value: e.id,
          label: e.name,
        })),
      onChange: e =>
        setPoolEquipmentGroup(e.target.value.map(r => r.value)),
      placeholder: `${translate('common:Select')}`,
    },
    {
      type: 'textField',
      label: `${translate('common:Equipment')}`,
      value: poolEquipmentName,
      onChange: e =>
        setPoolEquipmentName(e?.target?.value),
      placeholder: `${translate('common:Find')}`,
    },
  ]), [
    poolEquipmentType,
    poolEquipmentGroup,
    poolEquipmentName,
    equipmentTypes,
    equipmentGroups,
  ]);

  const renderPools = () => (
    <Accordion
      defaultExpanded
      onChange={() => setExpanded(!expanded)}
      expanded={expanded}
    >
      <AccordionSummary
        expandIcon={<ExpandLess />}
        id="1"
      >
        <Typography>{translate('common:AvailableEquipments')}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <div style={{ display: 'flex', width: '100%' }}>
          <PF2MEquipmentPoolFilter filters={filters} />
          <div style={{
            display: 'flex',
            marginTop: 10,
            width: '85%',
          }}
          >
            <PF2MEquipmentPool
              equips={
                applyFiltersToPoolList(
                  availablePoolEquips, poolEquipmentType, poolEquipmentGroup, poolEquipmentName
                )
              }
              onEquipClick={(equip) => {
                if (equip.equip_type_id === TRUCK) {
                  dispatch(setSelectedTruckAllocation(equip));
                  setIsTruckModalOpen(true);
                } else {
                  dispatch(setSelectedLoadAllocation(equip));
                  setIsLoadModalOpen(true);
                }
              }}
              onItemDropped={(id, type) => {
                if (type === DispatchDragNDropTypes.TRUCK) {
                  dispatch(deallocateTruckAllocations({
                    id,
                    refresh: false,
                    skipLoading: true,
                    dispatchLoading: true,
                  }));
                } else {
                  dispatch(deallocateLoadAllocations({
                    id,
                    refresh: false,
                    skipLoading: true,
                    dispatchLoading: true,
                  }));
                }
              }}
              headerText={translate('common:AvailableEquipments').toUpperCase()}
              operationTypeEffective
            />
            <PF2MEquipmentPool
              equips={
                applyFiltersToPoolList(
                  maintenancePoolEquips, poolEquipmentType, poolEquipmentGroup, poolEquipmentName
                )
              }
              onEquipClick={(equip) => {
                if (equip.equip_type_id === TRUCK) {
                  dispatch(setSelectedTruckAllocation(equip));
                  setIsTruckModalOpen(true);
                } else {
                  dispatch(setSelectedLoadAllocation(equip));
                  setIsLoadModalOpen(true);
                }
              }}
              onItemDropped={(id, type) => {
                if (type === DispatchDragNDropTypes.TRUCK) {
                  dispatch(deallocateTruckAllocations({
                    id,
                    refresh: false,
                    skipLoading: true,
                    dispatchLoading: true,
                  }));
                } else {
                  dispatch(deallocateLoadAllocations({
                    id,
                    refresh: false,
                    skipLoading: true,
                    dispatchLoading: true,
                  }));
                }
              }}
              headerText={translate('common:MaintenanceEquipments').toUpperCase()}
              customStyles={{ marginLeft: 10 }}
              operationTypeEffective
            />
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
  );

  const tableHeader = ({ span }) => (
    <th style={{
      paddingInline: '10px',
      alignItems: 'center',
      textAlign: 'center',
    }}
    >
      <span
        className={classes.labelTypeSelector}
        style={{ whiteSpace: 'nowrap' }}
      >
        {span}
      </span>
    </th>
  );

  const renderTableHeader = () => (
    <tr>
      {
        handle.active ? null : (
          <>
            {tableHeader({ span: translate('common:Priority') })}
            {tableHeader({ span: translate('common:Group') })}
          </>
        )
      }
      {tableHeader({ span: translate('common:Origin') })}
      {isDynamicEnable && tableHeader({ span: translate('common:DynamicAllocationAbrev') })}
      {tableHeader({ span: translate('common:LoadEquipment') })}
      {tableHeader({ span: translate('common:AllocatedTrucks') })}
    </tr>
  );

  const renderActionsButtons = () => {
    const options = [
      {
        icon: <icons.DynamicCustom fontSize="small" />,
        onClick: () => {
          setIsDynamicBulkUpdateConfirmationOpen(true);
          setDynamicBulkUpdateMessage('active')
          dispatch(updateIsTruckAllocationLoading(true));
        },
        variant: 'outlined',
        enabled: !handle.active && isDynamicEnable,
        buttonStyles: { borderRadius: '20px', height: '32px', width: '32px' },
        tooltipText: translate('common:EnableAllDynamicAlloc'),
      },
      {
        icon: <icons.DynamicCustomOff fontSize="small" />,
        onClick: () => {
          setIsDynamicBulkUpdateConfirmationOpen(true);
          setDynamicBulkUpdateMessage('inactive');
          dispatch(updateIsTruckAllocationLoading(true));
        },
        variant: 'outlined',
        enabled: !handle.active && isDynamicEnable,
        buttonStyles: { borderRadius: '20px', height: '32px', width: '32px' },
        tooltipText: translate('common:DisableAllDynamicAlloc'),
      },
      {
        icon: (
          <div style={{ position: 'relative', width: '22px', height: '30px' }}>
            <SettingsOutlinedIcon fontSize='small' />
            <icons.DynamicCustom style={{
              position: 'absolute',
              top: '-8px',
              right: '-12px',
              height: '22px',
              width: '22px',
            }} />
          </div>
        ),
        onClick: () => {
          setIsBulkInsertOpen(true);
        },
        variant: 'filled',
        enabled: !handle.active && isDynamicEnable,
        buttonStyles: { borderRadius: '20px', height: '32px', width: '32px' },
        tooltipText: translate('common:BulkConfigDynamicAlloc'),
      },
      {
        icon: <AddCircleOutlineRounded fontSize="small" />,
        onClick: () => {
          dispatch(setSelectedLoadAllocation(getSelectedAllocationInitialState()));
          setIsLoadModalOpen(true);
        },
        variant: 'filled',
        enabled: !handle.active,
      },
      {
        icon: <DeleteOutlineOutlined fontSize="small" />,
        onClick: () => setIsDeallocationAlertOpen(true),
        variant: 'outlined',
        enabled: !handle.active && authLevel === 1,
      },
    ];

    return (
      <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
        {options.filter(item => item.enabled).map((item, index) => (
          item.tooltipText ? (
            <PF2MTooltip title={item.tooltipText} key={index}>
              <PF2MIconButton
                icon={item.icon}
                onClick={item.onClick}
                variant={item.variant}
                buttonStyles={item.buttonStyles ?? {}}
              />
            </PF2MTooltip>
          ) : (
            <PF2MIconButton
              icon={item.icon}
              onClick={item.onClick}
              variant={item.variant}
              buttonStyles={item.buttonStyles ?? {}}
              key={index}
            />
          )
        ))}
        <PF2MFullScreenButton
          isFullScreenActive={handle.active}
          open={handle.enter}
          close={handle.exit}
          variant="outlined"
        />
      </div>
    );
  };

  const renderFilterTable = () => (
    <div
      style={{
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        padding: '20px 8px',
        gap: '24px',
      }}
    >
      <div style={{
        display: 'flex',
        gap: '45px',
      }}
      >
        <PF2MSearchInput
          value={filterTextOrigin}
          onChange={e => setFilterTextOrigin(e.target.value)}
          placeholder={translate('common:Find')}
          text={`${translate('common:SearchFor')} ${translate('common:Origin')}`}
          startIcon={<SearchIcon fontSize={'small'} color="primary" />}
        />
        <PF2MSearchInput
          value={filterTextLoad}
          onChange={e => setFilterTextLoad(e.target.value)}
          placeholder={translate('common:Find')}
          text={`${translate('common:SearchFor')} ${translate('common:LoadEquipment')}`}
          startIcon={<SearchIcon fontSize={'small'} color="primary" />}
        />
        <PF2MSearchInput
          value={filterTextTruck}
          onChange={e => setFilterTextTruck(e.target.value)}
          placeholder={translate('common:Find')}
          text={`${translate('common:SearchFor')} ${translate('common:TruckEquipment')}`}
          startIcon={<SearchIcon fontSize={'small'} color="primary" />}
        />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        {isTruckAllocationLoading && <CircularProgress size={24} />}
        {renderActionsButtons()}
      </div>
    </div>
  );

  const filterTruck = durationsByTruckOrigins
    .filter(truck => truck.equip_name?.toLowerCase().includes(filterTextTruck?.toLowerCase()))
    .map(truck => truck.load_allocation_excavator_name);

  const uniqueNames = [...new Set(filterTruck.filter(name => name !== null))];

  const filteredLoadAllocations = loadEquipStatusAllocations.filter((load) => {
    if (filterTextLoad !== '') {
      return load.equip_name?.toLowerCase().includes(filterTextLoad?.toLowerCase());
    }

    if (filterTextTruck !== '') {
      return uniqueNames.some(name => load.equip_name?.toLowerCase() === name?.toLowerCase());
    }

    return true;
  });

  const filterOrigins = filteredLoadAllocations.filter((load) => {
    if (filterTextOrigin !== '') {
      return load.origin_element_point_name
        ?.toLowerCase().includes(filterTextOrigin?.toLowerCase());
    }

    return true;
  });

  const renderAllocationTable = () => (
    <div style={{
      flex: 1,
      width: '100%',
      overflowY: 'scroll',
    }}>
      <table>
        <thead>
          {renderTableHeader()}
        </thead>
        <tbody>
          {
            filterOrigins && filterOrigins.filter(r => !!r.priority).length
              ? filterOrigins.filter(r => !!r.priority).map(
                (r, i) => {
                  const loadAllocationsGroup = loadAllocationsGroups?.find(
                    lag => lag.id === r?.dynamic_configuration?.group_id,
                  );
                  const isOverload = Boolean(loadAllocationsGroup?.is_overload);

                  return (
                    <AllocationRowV2
                      isFullscreen={handle.active}
                      key={r.id}
                      loadAllocation={r}
                      lmmByAllocationId={lmmByAllocationId}
                      onTruckDrop={(item, allocationId) => {
                        // if (checkEquipBlacklistAllocations(item, allocationId)) return;
                        dispatch(updateIsTruckAllocationLoading(true));
                        if (!item.load_allocation_id) {
                          dispatch(
                            updateTruckAllocations({
                              item,
                              key: 'load_allocation_id',
                              value: allocationId,
                              refresh: false,
                              skipLoading: true,
                              dispatchLoading: true,
                            }),
                          );
                          return;
                        }
                        const newTruckAllocation = {
                          ...item,
                          load_allocation_id: allocationId,
                        };
                        dispatch(setPendingTruckAllocationUpdate(newTruckAllocation, true));
                      }}
                      onLoadDrop={(item, materialMappings, trucksIds) => {
                        dispatch(updateLoadAllocations({
                          refresh: true,
                          skipLoading: true,
                          dispatchLoading: true,
                          item: { ...item, trucks: trucksIds },
                          materialMappings: materialMappings || [],
                          finallyCb: () => {
                            dispatch(updateIsTruckAllocationLoading(false));
                            dispatch(getLoadMaterialMappings());
                          },
                        }));
                      }}
                      loadAllocations={loadAllocations}
                      trucks={durationsByTruckOrigins.filter(x => x.load_allocation_id === r.id)}
                      isFirst={i === 0}
                      isLast={i === loadAllocations.length - 1}
                      openLoadModal={setIsLoadModalOpen}
                      openTruckModal={setIsTruckModalOpen}
                      dataTrucksOrigins={durationsByTruckOrigins.filter(
                        x => x.load_allocation_id === r.id,
                      )}
                      openUpdateDynamicAllocationModal={setIsUpdateDynamicAllocationModal}
                      dataExcavatorOrigins={durationsByExcavatorOrigins}
                      isDynamicEnable={isDynamicEnable}
                      isOverload={isOverload}
                    />
                  )
                },
              )
              : renderEmptyRow()
          }
        </tbody>
      </table>
      {/* <PF2MAlertDialog
        title={translate('common:Restriction')}
        description={
          <div style={styles.descriptionStyle}>{blacklistAllocationMessage}</div>
        }
        open={showBlacklistAllocationModal}
        onConfirm={() => {
          setBlacklistAllocationModal(false);
          setblacklistAllocationMessage(null);
        }}
        onClose={() => {
          setBlacklistAllocationModal(false);
          setblacklistAllocationMessage(null);
        }}
        hasCancel={false}
        badge
      /> */}
    </div>
  );

  return (
    <FullScreen handle={handle}>
      <div
        style={handle.active ? { height: '100vh' } : null}
        className={classes.tabContainer}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: handle.active ? '95%' : '82vh',
            backgroundColor: '#ffffff',
          }}
        >
          {renderFilterTable()}
          {renderAllocationTable()}
          {
            handle.active ? null : (
              <>
                {renderPools()}
              </>
            )
          }

        </div>
      </div>
      <div ref={rootRef}>
        <UpdateLoadAllocationModalV2
          isOpen={isLoadModalOpen}
          container={rootRef.current}
          close={() => setIsLoadModalOpen(false)}
        />

        <TruckAllocationModal
          modalData={isTruckModalOpen}
          closeModal={() => setIsTruckModalOpen(false)}
          container={rootRef.current}
        />

        <TruckAllocationModeModal
          isOpen={!!pendingTruckAllocationUpdate}
          close={() => dispatch(setPendingTruckAllocationUpdate(null))}
          container={rootRef.current}
        />

        <BulkDynamicAllocationModal
          isOpen={isBulkInsertOpen}
          close={() => setIsBulkInsertOpen(false)}
          container={rootRef.current}
        />

        <UpdateDynamicAllocationModal
          isOpen={isUpdateDynamicAllocationModal}
          close={() => setIsUpdateDynamicAllocationModal(false)}
          container={rootRef.current}
        />

        <PF2MAlertDialog
          hasCancel
          onClose={() => setIsDeallocationAlertOpen(false)}
          confirmText={translate('common:Yes')}
          description={translate('validation:ThisActionWillClearAllYourAllocations')}
          open={isDeallocationAlertOpen}
          onConfirm={() => {
            setIsDeallocationAlertOpen(false);
            dispatch(deallocateAllLoadAllocations(false, true, true));
          }}
          container={rootRef.current}
        />

        <PF2MAlertDialog
          hasCancel
          onClose={() => {
            setIsDynamicBulkUpdateConfirmationOpen(false);
            dispatch(updateIsTruckAllocationLoading(false));
          }}
          confirmText={translate('common:Yes')}
          description={bulkUpdateDynamicMessageMapper[dynamicBulkUpdateMessage]}
          open={isDynamicBulkUpdateConfirmationOpen}
          onConfirm={() => {
            setIsDynamicBulkUpdateConfirmationOpen(false);
            const isBulkActivate = dynamicBulkUpdateMessage === 'active';
            const existingLoadAllocationsIds = loadAllocations.filter(la => la.id).map(la => la.id);
            const payload = { load_allocation_ids: existingLoadAllocationsIds, active: isBulkActivate };
            dispatch(bulkUpdateDynamic({ payload }))
          }}
          container={rootRef.current}
        />
      </div>
    </FullScreen>
  );
};

AllocationsTabV2.propTypes = {
  classes: PropTypes.object.isRequired,
};

AllocationsTabV2.defaultProps = {};

export default withStyles(styles)(AllocationsTabV2);
